import { createFont } from 'tamagui'

const fontFamily = 'Barlow'

/**
 * Point system for font sizes and line heights
 *
 * 2 points for every size till 20 px then 4 points
 */
const barlow = createFont({
  family: fontFamily,
  size: {
    1: 12,
    2: 14,
    true: 12, // default size
    3: 16,
    4: 18,
    5: 20, // H6
    6: 24, // H5
    7: 28, // H4
    8: 32, // H3
    9: 36, // H2
    10: 40, // H1
    11: 44,
    12: 48,
    13: 52,
    14: 56,
    15: 60,
    16: 64,
    17: 68,
    18: 72,
    19: 76,
    20: 80,
  },
  lineHeight: {
    1: 14,
    true: 14,
    2: 17,
    3: 19,
    4: 22,
    5: 26,
    6: 30,
    7: 34,
    8: 38,
    9: 42,
    10: 44,
    11: 48,
    12: 52,
    13: 56,
    14: 60,
    15: 64,
    16: 68,
    17: 72,
    18: 76,
    19: 80,
    20: 84,
  },
})

export const fonts = {
  body: barlow,
  heading: barlow,
}
